import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: resolve => require(["@/pages/Home.vue"], resolve),
      children: [
        {
          path: "/",
          component: resolve => require(["@/pages/page.vue"], resolve)
        },
        {
          path: "/moduleFive",
          component: resolve =>
            require(["@/pages/moduleFive/moduleFive.vue"], resolve)
        },
        {
          path:'/IntroducePage',
          component: resolve => require(["@/pages/fileList/IntroducePage"], resolve)
        }
      ]
    },
   

  ]
});
